import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class CandidateListAction extends SendRequest
{
    async ActiveJobList(params)
    {
        try 
        {
              const result = await axios.get(API.client.candidates.ACTIVATE_JOB_LIST,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
              return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async downloadCandidateResumes(params)
    {
        try 
        {
            const result = await axios.post(API.client.candidates.DOWNLOAD_CANDIDATE_RESUMES,
            params,
            this.setCustomHeaderFileDownloadJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async deleteCandidate(params)
    {
        try 
        {
            const result = await axios.post(API.client.candidates.DELETE_CANDIDATES,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async addToJobs(params)
    {
        try 
        {
            const result = await axios.post(API.client.candidates.ADD_TO_JOBS,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }
}